import classNames from 'classnames'
import { useContext } from 'react'
import {SharedContext} from "../context/SharedContext"
import {SeekerContext} from "../context/SeekerContext"
import { NextLink } from '../commonComponents/NextLink'
export const PopularCategories = ({ categories = [] }) => {
  const { location } = useContext(SharedContext)
  const { setBody } = useContext(SeekerContext)

  const redirectHandler = async (bodyValue) => {
    await setBody((prv) => ({
      ...prv,
      selectedOptions: { ...prv?.selectedOptions, ...bodyValue }
    }))
  }

  const getRoute = (item) => {
    return `${(item?.title)
      .replace(/ /g, '')
      ?.replace(/\//g, '-and-')
      ?.replace('&', '-and-')}-jobs-in-${location?.name || location?.title}`
  }

  return (
    <div className="pt-[16px] pb-[40px] pl-[24px] pr-[12px]">
      <div className="pb-[16px] font-noto-sans text-[16px] font-bold leading-24 text-[#191919]">
        {`Popular Job Categories in ${location?.name || location?.title}`}
      </div>
      <div
        className={classNames(
          'mr-[12px] grid grid-cols-2 gap-x-[14px] font-noto-sans text-[12px] font-normal leading-16 text-[#191919]'
        )}
      >
        {categories?.map((item, index) => {
          return (
            <NextLink
              className="font-noto-sans text-[12px] font-normal leading-16 text-[#191919]"
              onClick={async () => {
                await redirectHandler({ 37: [item] })
              }}
              key={index}
              href={{
                pathname: 'jobsFiltering'
              }}
              as={`/jobs/${getRoute(item)}`}
              style={{ textDecoration: 'none' }}
              id={item.title + 'fields'}
            >
              <div
                key={index}
                className={classNames(index < categories?.length - 2 && 'pb-[12px]')}
              >
                {item?.title}
              </div>
            </NextLink>
          )
        })}
      </div>
    </div>
  )
}
